import appConfigs from "@configs/app";
import getBrowserLocale from "./browser.locale";

/**
 * @description I18n utilities class
 */
class I18nUtils {
  constructor() {
    this.defaultLocale = appConfigs.defaultLocale;
    this.fallbackLocale = appConfigs.fallbackLocale;
    this.supportedLocales = appConfigs.supportedLocales;
  }

  setDocumentLang(lang) {
    document.documentElement.lang = lang;
  }

  setDocumentTitle(newTitle) {
    document.title = newTitle;
  }

  getFallbackLocale() {
    return this.fallbackLocale;
  }

  getSupportedLocales() {
    let ret = [];

    for (const code of Object.keys(this.supportedLocales)) {
      ret.push({
        code,
        name: this.supportedLocales[code],
      });
    }

    return ret;
  }

  getStartingLocale(storedLocale) {
    // stored locale
    if (this.isSupportedLocale(storedLocale)) {
      return storedLocale;
    }

    // browser default
    const browserLocale = getBrowserLocale({ codeOnly: true });
    if (Object.keys(this.supportedLocales).includes(browserLocale)) {
      return browserLocale;
    }

    // system defined
    return this.defaultLocale;
  }

  isSupportedLocale(locale) {
    return Object.keys(this.supportedLocales).includes(locale);
  }
}

const i18nUtils = new I18nUtils();

export { i18nUtils };
